import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { 
  BookOpen, Search, Loader2, ChevronRight,
  FileText, ClipboardList, FlaskConical, HelpCircle, FileVideo
} from 'lucide-react';
import { studentPanelAPI } from '../../services/api';

const MATERIAL_TYPE_ICONS = {
  lecture: { icon: FileText, label: "Ma'ruza", color: '#3b82f6' },
  practice: { icon: ClipboardList, label: 'Amaliyot', color: '#10b981' },
  lab: { icon: FlaskConical, label: 'Laboratoriya', color: '#8b5cf6' },
  test: { icon: HelpCircle, label: 'Test', color: '#f59e0b' },
  other: { icon: FileVideo, label: 'Boshqa', color: '#64748b' }
};

const StudentSubjects = () => {
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      const response = await studentPanelAPI.getSubjects();
      setSubjects(response.data.subjects || []);
    } catch (error) {
      console.error('Fanlarni yuklashda xato:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredSubjects = subjects.filter(subject => 
    subject.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (loading) {
    return (
      <div className="loading-container">
        <Loader2 className="spinner" size={40} />
        <p>Yuklanmoqda...</p>
      </div>
    );
  }

  return (
    <div className="page-container">
      <header className="page-header">
        <div className="page-title">
          <h1><BookOpen size={28} /> Fanlarim</h1>
          <p>O'quv fanlari va materiallar</p>
        </div>
      </header>

      {/* Search */}
      <div className="search-bar">
        <Search size={20} />
        <input 
          type="text" 
          placeholder="Fanni qidirish..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Subjects Grid */}
      {filteredSubjects.length === 0 ? (
        <div className="empty-state">
          <BookOpen size={48} />
          <p>Fanlar topilmadi</p>
        </div>
      ) : (
        <div className="subjects-grid">
          {filteredSubjects.map(subject => (
            <div key={subject.id} className="subject-card-detailed student">
              <div className="subject-card-header">
                <div className="subject-icon student">
                  <BookOpen size={24} />
                </div>
                <div className="subject-info">
                  <h3>{subject.name}</h3>
                  {subject.description && (
                    <p className="subject-desc">{subject.description}</p>
                  )}
                </div>
              </div>
              
              <div className="subject-materials-summary">
                <div className="materials-total">
                  <FileText size={20} />
                  <span className="total-count">{subject.total_materials}</span>
                  <span className="total-label">material</span>
                </div>
                
                {subject.total_materials > 0 && (
                  <div className="materials-breakdown">
                    {Object.entries(subject.material_stats || {}).map(([type, stat]) => {
                      const typeInfo = MATERIAL_TYPE_ICONS[type];
                      const Icon = typeInfo?.icon || FileText;
                      return (
                        <div 
                          key={type} 
                          className="material-type-badge"
                          style={{ '--badge-color': typeInfo?.color }}
                        >
                          <Icon size={14} />
                          <span>{stat.count} {stat.label}</span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              
              <Link 
                to={`/student/subjects/${subject.id}/materials`}
                className="subject-card-action student"
              >
                <span>Materiallarni ko'rish</span>
                <ChevronRight size={18} />
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentSubjects;
